import React, { useState, useEffect } from 'react'
import { ThumbDown, ThumbUp, Pause } from '@mui/icons-material'
import { CircularProgress, Button } from '@mui/material'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { patch } from 'services/api'

import Colors from 'utils/Colors'
import { USER_ROLE } from 'utils/constants/application'
import styles from './styles'

const ManualAnalysisForm = (props) => {
  const { issueId, updateReview, role, isWaitingClarification } = props
  const classes = styles()
  
  const token = useSelector(state => state.auth.access_token)
  const userRole = useSelector(state => state.auth.user_role)
  const [error, setError] = useState(false)
  const [comment, setComment] = useState('')
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState(null)
  
  const reviewDecisions = {
    approved: 'APPROVED',
    reproved: 'REPROVED',
    waitingDecision: 'WAITING_DECISION',
  }
  
  const isUserAllowedToReview = (loggedUserRole, reviewUserRole) => (
    loggedUserRole === reviewUserRole || loggedUserRole === USER_ROLE.admin
    )
    
  const userCanReview = isUserAllowedToReview(userRole, role)
  const handleTextField = (value) => {
    setComment(value)
  }
  
  const handleSubmit = async (issue_id, decision, reviewer_comment) => {

    setLoading(true)
    
    const params = {
      uuid: issue_id,
      decision: decision,
      reviewer_comment: reviewer_comment,
      waiting_clarification: decision === reviewDecisions.waitingDecision,
    }

    const res = await patch({
      url: `/review`,
      token,
      data: params, 
    })

    if (res) {
      toast.success('Revisão enviada com sucesso')
      setResponse(res)
    }

    setLoading(false)
  }
  
  useEffect(() => {
    if (response) {
      updateReview(response)
    }
  }, [response, updateReview])
  
  const checkRequiredFields = (option) => {
    if (comment === '' && [reviewDecisions.reproved, reviewDecisions.waitingDecision].includes(option)) {
      setError(true)
      return
    }
    setError(false)

    let confirmMessage = 'Tem certeza?'
    if (option !== reviewDecisions.waitingDecision) {
      confirmMessage = `${confirmMessage} Esta decisão é final e não pode ser desfeita.`
    }

    // TODO: criar um componente de confirmação
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (confirm(confirmMessage)) {
      handleSubmit(issueId, option, comment)
    }
  }

  return userCanReview && (
    <div className={classes.root}>
      <div className={classes.comment}>
        
        <div>
          <span className={classes.label}>Justificativa</span> 
          {error && <span className={classes.errorText}> * Campo obrigatório</span>}
        </div>

        <textarea
          id='justificative'
          type="text"
          value={comment}
          className={classes.textArea}
          placeholder="Digite o motivo da decisão..."
          onChange={(event) => handleTextField(event.target.value)}
          style={{ borderColor: error ? Colors.red : 'inherit' }}
        />
      </div>

      <div className={classes.buttonContainer}>
        {loading ? (
          <CircularProgress size={32} style={{ marginRight: 20 }} />
        ) : (
          <div className={classes.buttonContainer}>
              {isWaitingClarification || <div className={classes.leftSubButtonContainer}>
                <Button 
                id='waitingDecision' 
                onClick={() => checkRequiredFields(reviewDecisions.waitingDecision)}
                className={classes.iconButton}
                style={{ marginRight: 100, backgroundColor: Colors.blueVariante, color: '#FFFFFF' }}
                startIcon={<Pause fontSize='small' /> }
              >
                  Aguardando esclarecimentos
              </Button>
            </div>}

            <div className={classes.rightSubButtonContainer}>
              <Button 
                id='approve' 
                onClick={() => checkRequiredFields(reviewDecisions.approved)}
                className={classes.iconButton}
                style={{ backgroundColor: Colors.green, color: '#FFFFFF' }}
                startIcon={<ThumbUp fontSize='small' />}
              >
                
                Aprovar
              </Button>
              <Button 
                id='reprove' 
                onClick={() => checkRequiredFields(reviewDecisions.reproved)}
                className={classes.iconButton}
                style={{ backgroundColor: Colors.red, color: '#FFFFFF' }}
                startIcon={<ThumbDown fontSize='small' /> }
              >
              
                Reprovar
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ManualAnalysisForm
